import api from 'api';
import { MetaType } from 'store/modules/Meta/types';
import { errHelper, Notify, unFormatCurrency } from 'utils';
import { PlatformProviderChargeType } from './types';

export const policyTypes = [
  {
    name: 'ISA (Cash)',
    value: '1'
  },
  {
    name: 'ISA (Stocks And Shares)',
    value: '5'
  },
  {
    name: 'Lifetime ISA (Cash)',
    value: '82'
  },
  {
    name: 'Lifetime ISA (Stocks And Shares)',
    value: '3'
  },
  {
    name: 'Junior ISA (Stocks And Shares)',
    value: '2'
  },
  {
    name: 'General Investment Account',
    value: '9'
  },
  {
    name: 'Insurance / Investment Bond',
    value: '6'
  },
  {
    name: 'Offshore Bond',
    value: '7'
  },
  {
    name: 'SIPP',
    value: '10'
  },
  {
    name: 'SIPP - Drawdown',
    value: '28'
  },
  {
    name: 'Personal Pension Plan',
    value: '12'
  },
  {
    name: 'Personal Pension - Drawdown',
    value: '30'
  },
  {
    name: 'QNUPS',
    value: '104'
  },
  {
    name: 'QROPS',
    value: '105'
  },
  {
    name: 'SSAS',
    value: '11'
  },
  {
    name: 'SSAS - Drawdown',
    value: '29'
  },
  { name: 'Enterprise Investment Scheme', value: '15' },
  { name: 'Venture Capital Trust', value: '123' },
  { name: 'Business Property Relief Scheme', value: '34' }
];

export const save = async (
  chargeData: PlatformProviderChargeType,
  currentChargeData: number[] | number,
  currentPolicyTypes: number[],
  aumRangeFrom: string,
  aumRangeTo: string,
  chargeValueTypeEnum: number,
  isFamilyLinked: boolean,
  selectedPlatformType: MetaType,
  selectedProviderType: MetaType,
  chargeType: string,
  platformIndex: number,
  updateCharge: Function,
  checkForm: Function,
  applyTo: any = null
) => {
  const errors = checkForm();
  if (!!errors && Object.values(errors).length > 0) return;
  if (currentChargeData === 0) {
    Notify.warn('Fixed charge must be more than zero');
    return (errors.fixed = 'Fixed charge must be more than zero');
  }
  if (!selectedPlatformType) {
    return Notify.warn('Please select a Platform');
  }
  if (!selectedProviderType) {
    return Notify.warn('Please select a Provider');
  }
  // if (
  //   !!currentChargeData ||
  //   (Array.isArray(currentChargeData) && currentChargeData.length === 0)
  // ) {
  //   const charge = chargeType.split('_')[0];
  //   Notify.warn(`You must add at least one ${charge} charge`);
  //   errors.stepped = `You must add at least one ${charge} charge`;
  //   setError(errors);
  //   return;
  // }
  // setError({});
  const dataToSave = chargeData as any;
  dataToSave.stepped_charge = [];
  dataToSave.tiered_charge = [];
  dataToSave.fixed_charge = null;
  dataToSave[chargeType] = currentChargeData;
  dataToSave.policy_type = currentPolicyTypes;
  dataToSave.aum_range = [aumRangeFrom, aumRangeTo].map(
    (ar: string, index: number) => {
      if (ar === '') return null;
      if (typeof ar === 'string') {
        const formattedValue = unFormatCurrency(ar);

        // Enforce aumRangeFrom to be 0 if aumRangeTo has a value
        if (index === 0 && aumRangeTo !== '') {
          return 0;
        }

        return formattedValue !== null ? formattedValue : 0;
      }
      return ar ?? 0;
    }
  );

  // If both values are null, reset the array
  if (dataToSave.aum_range[0] === null && dataToSave.aum_range[1] === null) {
    dataToSave.aum_range = [];
  }
  dataToSave.charge_value_type = chargeValueTypeEnum;
  dataToSave.family_linked = isFamilyLinked;
  dataToSave.policy_platform = Number(selectedPlatformType.value);
  dataToSave.policy_provider = Number(selectedProviderType.value);
  dataToSave.apply_to = applyTo ? Number(applyTo.value) : null;
  try {
    const chargeData =
      await api.providerPlatformChargesApi.addProviderPlatformCharge(
        dataToSave
      );
    Notify.success(`You have sucessfully created charge ${chargeData.data}`);
    dataToSave.id = chargeData.data;
    updateCharge(platformIndex, dataToSave);
  } catch (err) {
    errHelper(err);
  }
};
